




import AudioTrackConsumer from './AudioTrackConsumer.vue';
import { useMediasoupConsumer } from '@/composables';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'MediasoupAudioConsumer',
  components: {
    AudioTrackConsumer,
  },
  props: {
    producerId: {
      type: String,
      required: true,
    },
    participantId: {
      type: String,
      required: true,
    },
    producerName: {
      type: String,
      required: true,
    },
    muted: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const { consumer, track } = useMediasoupConsumer(props);

    return {
      consumer,
      track,
    };
  },
});
